<script>
    import {getStyleValue} from '../../Common/tools';
    import TextEditor from "../../Common/TextEditor.svelte";

    export let data, meta, globalStyle, onChange, isChild = false;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {text: val});
    }

    let align;
    $: {
        if (!data.buttonStyle.position || data.buttonStyle.position === '') {
          align = '';
        } else if (data.buttonStyle.position === 'left') {
          align = 'component-left';
        } else if (data.buttonStyle.position === 'center') {
          align = 'component-center';
        } else {
          align = 'component-right';
        }
    }
</script>
{#if isChild}
    <table class="{align}" style="border-radius: 3px;" cellspacing="0" cellpadding="0"
           bgcolor={data.buttonStyle.backgroundColor}>
        <tbody>
        <tr>
            <td>
                <div style="border: 0 solid {data.buttonStyle.backgroundColor}; line-height: 1.4; display: inline-block; font-size: 16px; font-weight: 400; padding: 15px 50px 15px 50px; text-decoration: none; text-align: center;" class="email-button">
                    <TextEditor bind:data={data.text} meta={meta} onChange={change} isMinimalistic={true} emailEditor={true} />
                </div>
            </td>
        </tr>
        </tbody>
    </table>
{:else}
    <tr>
        <th class="column column-st" width="{getStyleValue(globalStyle.width, 600)}" align="center">
            <table class="{align}" style="border-radius: 3px;" cellspacing="0" cellpadding="0"
                   bgcolor={data.buttonStyle.backgroundColor}>
                <tbody>
                <tr>
                    <td>
                        <div style="border: 0 solid {data.buttonStyle.backgroundColor}; line-height: 1.4; display: inline-block; font-size: 16px; font-weight: 400; padding: 15px 50px 15px 50px; text-decoration: none; text-align: center;" class="email-button">
                            <TextEditor bind:data={data.text} meta={meta} onChange={change} isMinimalistic={true} emailEditor={true} style="line-height: 1.4;"/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </th>
    </tr>
{/if}
